export enum Status {
  open = 1,
  closed = 2,
  resolved = 3,
}
